import { AgentInstructionsType } from 'pbts/c1/api/user/v1/user'
import { IntlShape } from 'react-intl'

export const AgentInstructionsTypeToText = (intl: IntlShape, type: AgentInstructionsType): string => {
    switch (type) {
        case AgentInstructionsType.CONCISE:
            return intl.formatMessage({ id: 'agent_instructions_type_concise', defaultMessage: 'Concise and efficient' })
        case AgentInstructionsType.VERBOSE:
            return intl.formatMessage({ id: 'agent_instructions_type_verbose', defaultMessage: 'Verbose and detailed' })
        case AgentInstructionsType.CUSTOM:
            return intl.formatMessage({ id: 'agent_instructions_type_custom', defaultMessage: 'Custom' })
        default:
            return intl.formatMessage({ id: 'agent_instructions_type_unspecified', defaultMessage: 'None' })
    }
}
